<span class="relative inline-block">
  <button
    type="button"
    class="relative w-10 h-10 rounded-full flex items-center justify-center transition-colors hover:bg-white/15"
    style="color: var(--p-primary-contrast-color)"
    [attr.aria-label]="'messages.title' | translate"
    (click)="popoverRef.toggle($event)"
  >
    @if (hasUnread()) {
      <span
        class="motion-safe:animate-ping absolute inset-1 rounded-full bg-red-500 opacity-75"
      ></span>
    }
    <i
      class="pi pi-comment text-lg relative"
      [class.text-red-500]="hasUnread()"
    ></i>
  </button>
  @if (hasUnread()) {
    <span class="absolute top-1 right-1 flex h-2.5 w-2.5">
      <span
        class="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white dark:ring-surface-900"
      ></span>
    </span>
  }
</span>

<p-popover #popoverRef (onShow)="onPopoverShow()">
  <div class="w-80">
    <h4 class="text-sm font-semibold mb-2">
      {{ 'messages.title' | translate }}
    </h4>

    @if (messagesLoading() && messages().length === 0) {
      <div class="flex flex-col gap-2">
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
      </div>
    } @else if (messagesError()) {
      <span class="text-xs text-red-500">
        {{ 'messages.load_error' | translate }}
      </span>
    } @else if (messages().length === 0) {
      <span class="text-xs text-surface-500">
        {{ 'messages.empty' | translate }}
      </span>
    } @else {
      <div class="flex flex-col gap-1 max-h-80 overflow-y-auto">
        @for (message of messages(); track message.id) {
          <button
            type="button"
            class="text-left p-2 rounded hover:bg-surface-100 dark:hover:bg-surface-800"
            (click)="openMessage(message, popoverRef)"
          >
            <div class="text-sm font-medium">{{ getTitle(message) }}</div>
            <div class="text-xs text-surface-500 line-clamp-2 break-words">
              {{ getSummary(message) }}
            </div>
            @if (getMeta(message); as meta) {
              <div class="text-[11px] text-surface-400 truncate">
                {{ meta }}
              </div>
            }
            @if (message.content.justification) {
              <div
                class="text-[11px] text-surface-400 line-clamp-2 break-words italic"
              >
                {{ 'messages.detail.justification' | translate }}:
                {{ message.content.justification }}
              </div>
            }
          </button>
        }
      </div>

      @if (hasMore()) {
        <div class="pt-2 text-center">
          <p-button
            [label]="'messages.load_more' | translate"
            [text]="true"
            size="small"
            [loading]="messagesLoading()"
            (click)="loadMore()"
          />
        </div>
      }
    }
  </div>
</p-popover>

<cam-message-detail-dialog
  [visible]="detailDialogVisible()"
  [message]="selectedMessage()"
  (visibleChange)="detailDialogVisible.set($event)"
  (messageRead)="onMessageRead()"
/>
